import Loadable from 'react/components/loadable';

const DashboardV2PromptModal = Loadable({
  loader: () => import('../../pages/dashboard/components/dashboard_v2_prompt_modal'),
  type: 'modal',
});

angular.module('gym').value('DashboardV2PromptModal', DashboardV2PromptModal);
